import { render } from "./UploadFile.vue?vue&type=template&id=15636140&scoped=true"
import script from "./UploadFile.vue?vue&type=script&lang=js"
export * from "./UploadFile.vue?vue&type=script&lang=js"

import "./UploadFile.vue?vue&type=style&index=0&id=15636140&scoped=true&lang=css"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15636140"]])

export default __exports__